






































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { demoServer } from '../../../../../api/installServer';
import logger from 'vuex/types/logger';
import TreeContainer from '@/components/tree/tree.vue';
import { roleServe } from '../../../../../api/installServer';
import { arrayToTree } from '@/util/arrayToTree';
import { deepClone } from '@/util/deepClone';
import { menuServe } from '../../../../../api/installServer'; // 授权功能页面的 菜单管理 的接口
@Component({
  components: { TreeContainer },
})
export default class RoleAssignFunctionalPermissions extends Vue {
  @Prop(String) rowId!: string; // 传递给编辑页面,角色分配功能权限页面的表单数据对象
  editRoleFlag = 4; // 角色分配功能权限页面的flag
  scrollbar = true;
  // 表单数据对象
  basicInfoData: any = {
    name: '', // 角色名称
    // spaceId: '', // 角色编码
    menuIdList: [], // 授权功能菜单的树状图
  };
  basicInfoDataClone: any = {};

  //树状图部分的数据
  unKnownData: Array<any> = []; // 树状图数据
  unKnownDataPC: Array<any> = []; // 树状图数据
  unKnownDataAPP: Array<any> = []; // 树状图数据
  // 树状图的数组
  unKnownProps: object = {
    children: 'children',
    label: 'name',
  };

  private check: any = [1, 4, 10, 2, 3, 9, 12, 5, 7];

  menuIdListPC: any = [];
  menuIdListAPP: any = [];
  arrPC: any = [];
  arrAPP: any = [];

  // 表单验证规则对象
  formRules: object = {
    name: [{ required: true }], // 角色名称
    // spaceId: [{ required: true }], // 角色编码
  };

  mounted() {
    this.hasScrollbar();
  }

  hasScrollbar() {
    const dom: any = document.getElementById('main_box');
    this.scrollbar = dom.scrollHeight > dom.clientHeight || dom.offsetHeight > dom.clientHeight;
  }

  async created() {
    // 初始化树状图的数据
    await this.getTreeData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 通过id 获取数据
   * @param1 暂无
   * @returns 暂无
   */
  getInfo() {
    // 通过id 获取数据
    if (this.editRoleFlag === 4) {
      roleServe
        .getRoleLineData(this.rowId)
        .then((res: any) => {
          this.basicInfoData = res.data;
          this.basicInfoDataClone = deepClone(res.data);
          this.$forceUpdate();
          // console.log('res', res)  // 每一行的数据

          this.basicInfoDataClone.menuIdList.forEach((item: any) => {
            if (this.arrAPP.findIndex((a: any) => a.id === item) > -1) {
              this.menuIdListAPP.push(item);
            } else if (this.arrPC.findIndex((a: any) => a.id === item) > -1) {
              this.menuIdListPC.push(item);
            }
          });
        })
        .catch((error: any) => {
          // this.$message({
          //   type: 'info',
          //   message: '网络错误，请检查网络',
          // });
          console.log(error);
        });
    }
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 获取 树状图 的数据
   * @param1 暂无
   * @returns 暂无
   */
  getTreeData() {
    // 树状图的数组
    menuServe
      .getAllSysMenu({})
      .then((res: any) => {
        if (res.code === '200') {
          // console.log('res', res); // 输出全部数据
          const arrPC: any = [];
          const arrAPP: any = [];
          res.data.forEach((item: any) => {
            if (item.mode === 'pc') {
              arrPC.push(item);
            }
            if (item.mode === 'app') {
              arrAPP.push(item);
            }
          });
          // this.unKnownData = arrayToTree(res.data);
          this.arrPC = arrPC;
          this.arrAPP = arrAPP;
          this.unKnownDataPC = arrayToTree(arrPC);
          this.unKnownDataAPP = arrayToTree(arrAPP);
          this.getInfo();
        }
      })
      .catch(() => {
        this.$message.error('初始化树状图失败，请稍后重试！');
      });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 获取 未知部分的 数据
   * @param1 暂无
   * @returns 暂无
   */
  checkDataPC(data: any) {
    // console.log(data); // 需要保存的 idList
    const menuData = data.idList;
    console.log(menuData);
    this.menuIdListPC = menuData;
  }

  checkDataAPP(data: any) {
    // console.log(data); // 需要保存的 idList
    const menuData = data.idList;
    console.log(menuData);
    this.menuIdListAPP = menuData;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击按钮保存 角色分配功能权限 授权功能菜单 树状图  的页面内容
   * @param1 暂无
   * @returns 暂无
   */
  saveEditRole(): void {
    // alert('保存');
    console.log(this.menuIdListAPP);
    console.log(this.menuIdListPC);
    this.basicInfoDataClone.menuIdList = [...this.menuIdListAPP, ...this.menuIdListPC];
    (this.$refs.formRef as any).validate((valid: any) => {
      if (valid) {
        if (this.editRoleFlag === 4) {
          // 修改 授权功能菜单 树状图的数据
          // console.log(this.basicInfoData);
          roleServe
            .editRoleData({ ...this.basicInfoDataClone })
            .then((res: any) => {
              // if (res.code === '200') {
              this.backRole(); // 跳转到 index 页面
              this.$message.success('修改授权功能菜单成功！');
              // this.$router.go(0); // 刷新
              // }
              // console.log("新增的",res)
            })
            .catch(() => {
              this.$message.error('修改授权功能菜单失败,请稍后重试!');
            });
        }
      } else {
        return false;
      }
    });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击按钮返回角色管理界面
   * @param1 暂无
   * @returns 暂无
   */
  backRole(): void {
    this.$emit('close');
  }
}
